import React, { useState, useEffect } from "react";
import { connectToContract } from "./CrownContract";
import { FaLock, FaUnlock, FaGift } from "react-icons/fa";
import { formatEther, parseEther } from "ethers";

const StakeActions = ({ provider, account }) => {
  const [tokenAmount, setTokenAmount] = useState("");
  const [balance, setBalance] = useState("0");
  const [stakedAmount, setStakedAmount] = useState("0");
  const [pendingRewards, setPendingRewards] = useState("0");
  const [transactionFee, setTransactionFee] = useState("0");
  const [dailyRewardRate, setDailyRewardRate] = useState("0");

  useEffect(() => {
    const fetchData = async () => {
      if (!provider || !account) return;

      try {
        const contract = await connectToContract(provider);
        const [bal, stakeInfo, rewards, feeRate, rewardRate] = await Promise.all([
          contract.balanceOf(account),
          contract.stakerInfo(account),
          contract.getPendingRewards(account),
          contract.transactionFeeRate(),
          contract.DAILY_REWARD_RATE(),
        ]);
        setBalance(formatEther(bal || 0));
        setStakedAmount(formatEther(stakeInfo.stakedAmount || 0));
        setPendingRewards(formatEther(rewards || 0));
        setTransactionFee((Number(feeRate) / 100).toFixed(2)); // Převod na % (např. 50 -> 0.50%)
        setDailyRewardRate((Number(rewardRate) / 100).toFixed(2)); // Převod na % (např. 2 -> 0.02%)
      } catch (error) {
        console.error("Error fetching stake data:", error);
      }
    };
    fetchData();
  }, [provider, account]);

  const handleStake = async () => {
    if (!provider || !account) {
      alert("Connect your wallet first!");
      return;
    }
    if (!tokenAmount || isNaN(tokenAmount) || parseFloat(tokenAmount) <= 0) {
      alert("Please enter a valid token amount!");
      return;
    }
    try {
      const contract = await connectToContract(provider);
      const tx = await contract.stake(parseEther(tokenAmount));
      await tx.wait();
      alert("Staking successful!");
      const [bal, stakeInfo, rewards] = await Promise.all([
        contract.balanceOf(account),
        contract.stakerInfo(account),
        contract.getPendingRewards(account),
      ]);
      setBalance(formatEther(bal || 0));
      setStakedAmount(formatEther(stakeInfo.stakedAmount || 0));
      setPendingRewards(formatEther(rewards || 0));
    } catch (error) {
      console.error("Error during staking:", error);
      alert(`Staking failed: ${error.message}`);
    }
  };

  const handleUnstake = async () => {
    if (!provider || !account) {
      alert("Connect your wallet first!");
      return;
    }
    try {
      const contract = await connectToContract(provider);
      const tx = await contract.unstake();
      await tx.wait();
      alert("Unstaking successful!");
      const [bal, stakeInfo, rewards] = await Promise.all([
        contract.balanceOf(account),
        contract.stakerInfo(account),
        contract.getPendingRewards(account),
      ]);
      setBalance(formatEther(bal || 0));
      setStakedAmount(formatEther(stakeInfo.stakedAmount || 0));
      setPendingRewards(formatEther(rewards || 0));
    } catch (error) {
      console.error("Error during unstaking:", error);
      alert(`Unstaking failed: ${error.message}`);
    }
  };

  const handleClaimRewards = async () => {
    if (!provider || !account) {
      alert("Connect your wallet first!");
      return;
    }
    try {
      const contract = await connectToContract(provider);
      const tx = await contract.claimRewardStake();
      await tx.wait();
      alert("Rewards claimed successfully!");
      const [bal, stakeInfo, rewards] = await Promise.all([
        contract.balanceOf(account),
        contract.stakerInfo(account),
        contract.getPendingRewards(account),
      ]);
      setBalance(formatEther(bal || 0));
      setStakedAmount(formatEther(stakeInfo.stakedAmount || 0));
      setPendingRewards(formatEther(rewards || 0));
    } catch (error) {
      console.error("Error claiming rewards:", error);
      alert(`Reward claim failed: ${error.message}`);
    }
  };

  return (
    <div>
      <h2>
        <FaLock className="icon" /> Stake
      </h2>
      <p>Balance: {balance} Crown</p>
      <p>Staked Amount: {stakedAmount} Crown</p>
      <p>Pending Rewards: {pendingRewards} Crown</p>
      <p>Transaction Fee: {transactionFee}%</p>
      <p>Daily Reward Rate: {dailyRewardRate}%</p>
      <div className="action-container">
        <div className="action-box">
          <h3>Stake</h3>
          <input
            type="text"
            placeholder="Token Amount"
            value={tokenAmount}
            onChange={(e) => setTokenAmount(e.target.value)}
          />
          <button onClick={handleStake}>
            <FaLock /> Stake
          </button>
        </div>
        <div className="action-box">
          <h3>Unstake</h3>
          <button onClick={handleUnstake}>
            <FaUnlock /> Unstake All
          </button>
        </div>
        <div className="action-box">
          <h3>Claim Rewards</h3>
          <button onClick={handleClaimRewards}>
            <FaGift /> Claim Rewards
          </button>
        </div>
      </div>
    </div>
  );
};

export default StakeActions;